import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  herosliders: [],
  loading: false,
  error: null,
};

const herosliderSlice = createSlice({
  name: "heroslider",
  initialState,
  reducers: {
    fetchHeroSliders: (state) => {
      state.loading = true;
    },
    fetchHeroSlidersSuccess: (state, action) => {
      state.loading = false;
      state.herosliders = action.payload;
    },
    fetchHeroSlidersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchHeroSliders,
  fetchHeroSlidersSuccess,
  fetchHeroSlidersFailure,
} = herosliderSlice.actions;

export default herosliderSlice.reducer;
